import type { ReactNode } from 'react'

type Tone = 'info' | 'error' | 'empty'

type Props = {
  tone?: Tone
  title?: string
  children?: ReactNode
  /** Rendered after the message — e.g. a retry button. */
  action?: ReactNode
}

/**
 * The single presentation for loading / empty / error states, so no page invents
 * its own wording or silently renders nothing.
 */
export function StatusMessage({ tone = 'info', title, children, action }: Props) {
  return (
    <div className={`status status-${tone}`} role={tone === 'error' ? 'alert' : undefined}>
      {title ? <p className="status-title">{title}</p> : null}
      {children ? <div className="status-body">{children}</div> : null}
      {action ? <div className="status-action">{action}</div> : null}
    </div>
  )
}
